import { ConnectionStatus } from "./types";

export const CONNECTION_STATUS_ORDER: Record<ConnectionStatus, number> = {
  app_update_required: 3,
  offline: 2,
  warning: 1,
  online: 0,
};

export const CONNECTION_STATUS_LABEL: Record<ConnectionStatus, string> = {
  app_update_required: "App update required",
  online: "Online",
  warning: "Warning",
  offline: "Offline",
};
